export * from './Tag';
export type { TagProps, TextTagAppearance, DeletableTagAppearance } from './types';
